// frontend/src/native/pushPreferences.ts
//
// A2: Steuerung des PROAKTIVEN Push-Berechtigungs-Dialogs.
//
// Standard = „hoher Pace für wiederkehrende User": ein wiederkehrender Nutzer wird
// direkt nach dem Login aktiv nach der Push-Berechtigung gefragt (er kennt die App).
// Ein brandneuer Nutzer wird beim ALLERERSTEN Login NICHT sofort gefragt (erst
// onboarden lassen) — ab der nächsten Session gilt er als wiederkehrend.
//
// Einstellbar: Der Nutzer kann den proaktiven Dialog in den Benachrichtigungs-
// Einstellungen abschalten (dann wird die Berechtigung nur noch beim expliziten
// Einschalten des Push-Toggles angefragt). Der Wert ist persistent (localStorage).

import { clearPref, readPref, writePref } from '../shared/clientPrefs';

const PROACTIVE_ENABLED_KEY = 'lorath_push_proactive_enabled';
const SEEN_BEFORE_KEY = 'lorath_push_seen_before';
const PUSH_PROMPT_DONE_KEY = 'ff_push_prompt_done';

function readFlag(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeFlag(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* Privatmodus / Storage blockiert — best-effort */
  }
}

/** Standard TRUE — nur explizit auf '0' gesetzt gilt als deaktiviert. */
export function isProactivePushEnabled(): boolean {
  return readFlag(PROACTIVE_ENABLED_KEY) !== '0';
}

export function setProactivePushEnabled(enabled: boolean): void {
  writeFlag(PROACTIVE_ENABLED_KEY, enabled ? '1' : '0');
  if (enabled) {
    // Nur ein bewusstes Wiedereinschalten in den Einstellungen darf den bereits
    // beantworteten Startup-Hinweis fuer einen spaeteren App-Start reaktivieren.
    clearPref(PUSH_PROMPT_DONE_KEY);
  }
}

/** True, sobald der Startup-Hinweis mit einer der beiden Optionen beantwortet wurde. */
export function isStartupPushPromptDone(): boolean {
  return readPref(PUSH_PROMPT_DONE_KEY) !== null;
}

/** Persistiert die Entscheidung Cookie + localStorage (iOS-Kaltstart-sicher). */
export function markStartupPushPromptDone(): void {
  writePref(PUSH_PROMPT_DONE_KEY, '1');
}

/** True, sobald der Nutzer schon einmal eingeloggt war (wiederkehrend). */
export function hasLoggedInBefore(): boolean {
  return readFlag(SEEN_BEFORE_KEY) === '1';
}

export function markLoggedInBefore(): void {
  writeFlag(SEEN_BEFORE_KEY, '1');
}
